import { ITagOption } from '../interfaces/productTags';

import { OrganizationType } from './organizationType';

export enum FILTERS_NAME {
  REVIEW_TAG = 'reviewTag',
  SORT_BY = 'sortBy',
  IS_ASC_SORTING = 'isAscSorting',
  ORGANIZATION_TYPE = 'organizationType',
  USER_RATING_TYPE = 'userRatingType',
  LOCATION = 'location',
  PRODUCT_CATEGORY_BY_PERSON = 'productCategoryByPerson',
}

export enum PRODUCT_CATEGORIES_BY_PERSON {
  ALL = 'all',
  NATURAL = 'natural',
  LEGAL = 'legal',
}

export const ROUTE_PRODUCT_CATEGORY_TO_FILTER = {
  'dlya-predprinimatelej': PRODUCT_CATEGORIES_BY_PERSON.LEGAL,
  'dlya-chastnyh-lic': PRODUCT_CATEGORIES_BY_PERSON.NATURAL,
};

export const FILTER_TO_ROUTE_PRODUCT_CATEGORY = {
  [PRODUCT_CATEGORIES_BY_PERSON.LEGAL]: 'dlya-predprinimatelej',
  [PRODUCT_CATEGORIES_BY_PERSON.NATURAL]: 'dlya-chastnyh-lic',
};

export enum REVIEWS_CATEGORY {
  ALL = 'all',
  MORE_THAN_10 = 'Min10',
  MORE_THAN_50 = 'Min50',
  MORE_THAN_100 = 'Min100',
  MORE_THAN_300 = 'Min300',
  MORE_THAN_500 = 'Min500',
}

export enum SORT_BY_PARAM {
  COMPLEX_CALCULATED_RATING_VALUE = 'complexCalculatedRatingValue',
  REVIEWS_COUNT = 'reviewsCount',
  ANSWERS_COUNT = 'answersCount',
  SOLVED_PROBLEMS = 'solvedProblems',
  // SPEED = 'speed',
}

export type FILTERS<ReviewTagType = ITagOption, AscSortingType = boolean> = {
  [FILTERS_NAME.ORGANIZATION_TYPE]?: OrganizationType;
  [FILTERS_NAME.REVIEW_TAG]: ReviewTagType;
  [FILTERS_NAME.IS_ASC_SORTING]: AscSortingType;
  [FILTERS_NAME.SORT_BY]: SORT_BY_PARAM;
  [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY;
  [FILTERS_NAME.LOCATION]: number;
  [FILTERS_NAME.PRODUCT_CATEGORY_BY_PERSON]: PRODUCT_CATEGORIES_BY_PERSON;
};

export const DEFAULT_UNKNOWN_TAG: ITagOption = {
  value: '',
  key: 'Unknown',
  label: 'Все услуги',
};

export const DEFAULT_FILTERS: FILTERS = {
  [FILTERS_NAME.REVIEW_TAG]: DEFAULT_UNKNOWN_TAG,
  [FILTERS_NAME.IS_ASC_SORTING]: false,
  [FILTERS_NAME.SORT_BY]: SORT_BY_PARAM.COMPLEX_CALCULATED_RATING_VALUE,
  [FILTERS_NAME.USER_RATING_TYPE]: REVIEWS_CATEGORY.MORE_THAN_100,
  [FILTERS_NAME.LOCATION]: null,
  [FILTERS_NAME.PRODUCT_CATEGORY_BY_PERSON]: PRODUCT_CATEGORIES_BY_PERSON.ALL,
};

export const FilterNameToAnalyticAction = {
  [FILTERS_NAME.REVIEW_TAG]: 'Вид продукта',
  [FILTERS_NAME.USER_RATING_TYPE]: 'Количество отзывов',
  [FILTERS_NAME.LOCATION]: 'Город',
  [FILTERS_NAME.PRODUCT_CATEGORY_BY_PERSON]: 'Категория продукта',
};

export const PRODUCT_CATEGORY_TO_LEGAL = {
  [PRODUCT_CATEGORIES_BY_PERSON.NATURAL]: false,
  [PRODUCT_CATEGORIES_BY_PERSON.LEGAL]: true,
  [PRODUCT_CATEGORIES_BY_PERSON.ALL]: null,
};

export enum PRODUCT_CATEGORY_ALIAS {
  BANKI_ALL = 'banki-obshee',
  BANKI_LEGAL = 'banki-bizness',
  BANKI_NATURAL = 'banki-fiziki',
  INSURANCE_ALL = 'strahovie-obshee',
}

export const PRODUCT_CATEGORY_LABELS = {
  [PRODUCT_CATEGORIES_BY_PERSON.ALL]: 'Все услуги',
  [PRODUCT_CATEGORIES_BY_PERSON.NATURAL]: 'Физлицам',
  [PRODUCT_CATEGORIES_BY_PERSON.LEGAL]: 'Юрлицам',
};

export const REVIEWS_COUNT_LABELS = {
  [REVIEWS_CATEGORY.ALL]: 'Любое количество отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_10]: 'Более 10 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_50]: 'Более 50 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_100]: 'Более 100 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_300]: 'Более 300 отзывов',
  [REVIEWS_CATEGORY.MORE_THAN_500]: 'Более 500 отзывов',
};
